<div class="report-preview">
    <div class="report-preview__header">
        <h1 class="report-preview__header-title">Preview do Dash</h1>
        <div class="report-preview__header-actions">
            <span
                class="text-14-semi-bold color-text-petroleum"
                [matTooltip]="
                    isMultiSource
                        ? 'Não é possível abrir o relatório antigo porque ele não suporta múltiplas fontes de dados. Para acessá-lo, gere um Dash usando apenas uma fonte de dados.'
                        : ''
                "
                [class.custom-disabled]="isMultiSource || loading"
            >
                @if (!isMultiSource) {
                    <a
                        [href]="getOldUrlReport()"
                        class="color-text-cyan-primary"
                        target="_blank"
                        (click)="onClickOldReport()"
                        >Acessar</a
                    >
                } @else {
                    <span class="color-text-cyan-primary">Acessar</span>
                }
                o relatório antigo.
            </span>
            <div class="divider"></div>

            <dsn-button
                [rocketBadge]="
                    accountingPlanService.features?.['IAContador'] || loading
                        ? false
                        : true
                "
                [label]="'IA'"
                [type]="'tertiary'"
                [size]="'medium'"
                [iconLeftCustom]="'/images/logos/nanda-icon-logo.svg'"
                [fontWeight]="'bold'"
                [typeButton]="'button'"
                [iconSizeCustom]="'large'"
                [disabled]="loading"
                (onClick)="onOpenChat()"
            ></dsn-button>

            <dsn-button
                [onlyIcon]="'fa-solid fa-file-pdf'"
                [matTooltip]="'Gerar PDF do Dash'"
                type="tertiary"
                [size]="'medium'"
                [disabled]="loading"
                (click)="onDownload()"
            ></dsn-button>
            <dsn-button
                [onlyIcon]="'fas fa-link'"
                [matTooltip]="'Copiar link do Dash'"
                type="tertiary"
                [size]="'medium'"
                (onClick)="onCopyLink()"
                [disabled]="loading"
            ></dsn-button>
            <dsn-button
                [iconLeft]="'fa-regular fa-envelope'"
                [label]="'E-mail'"
                type="tertiary"
                [size]="'medium'"
                (onClick)="onOpenDialogEmail()"
                [disabled]="loading"
            ></dsn-button>
            <dsn-button
                iconLeft="fab fa-whatsapp"
                [label]="'WhatsApp'"
                type="primary"
                [size]="'medium'"
                (onClick)="onOpenDialogWpp()"
                [disabled]="loading"
            ></dsn-button>
        </div>
    </div>
    <div class="report-preview__content">
        <div
            id="ReportNotesNavigation"
            class="report-preview__left-side dsn-scrollbar scroll-secondary"
            [ngStyle]="{
                width: showLeftSide ? '25%' : '0',
                transition: '0.3s'
            }"
        >
            <div
                [ngStyle]="{
                    width: '23vw',
                    minWidth: '23vw'
                }"
            >
                <app-report-notes-navigation
                    [class]="{ disabled: loading || loadingScroll }"
                    [visualizations]="report?.visualizations?.visualzations"
                    (handleAccordion)="onChangeAccordion($event)"
                    [loading]="loading"
                    [company]="company"
                    [report]="report"
                    (handleChangeVisualizationsVisible)="
                        onChangeVisualizationsVisible()
                    "
                ></app-report-notes-navigation>
            </div>
        </div>

        <div
            class="report-preview__button"
            [ngStyle]="{ left: showLeftSide ? 'calc(25% - 20px)' : '5px' }"
        >
            <dsn-button-rounded
                type="tertiary"
                icon="{{ iconButton }}"
                (click)="onToggleNavigation()"
            ></dsn-button-rounded>
        </div>
        <div
            class="report-preview__right-side"
            [ngStyle]="{ width: showLeftSide ? '75%' : '100%', height: '100%' }"
            fxLayout="column"
        >
            <div
                class="report-preview__right-side-header"
                fxLayout="row"
                fxLayoutAlign="start center"
            >
                <div
                    class="info-description"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                >
                    <i
                        class="fas fa-info-circle"
                        style="margin-right: var(--spacing-8)"
                    ></i>
                    <span
                        >A exibição pode variar dependendo do
                        <b>dispositivo</b> ou do
                        <b>método de compartilhamento</b> utilizado.</span
                    >
                </div>
                <span fxFlex></span>
                <div class="devices" fxLayout="row" fxLayoutAlign="end center">
                    <dsn-button-rounded
                        [type]="'secondary'"
                        [matTooltip]="'Visualize o Dash desktop'"
                        [icon]="'fas fa-desktop-alt'"
                        [disabled]="false"
                        [size]="'medium'"
                        [active]="device === 'desktop'"
                        (click)="onSelectDevice('desktop')"
                    ></dsn-button-rounded>
                    <dsn-button-rounded
                        [matTooltip]="'Visualize o Dash mobile'"
                        [type]="'secondary'"
                        [icon]="'fas fa-mobile'"
                        [disabled]="false"
                        [size]="'medium'"
                        [active]="device === 'mobile'"
                        (click)="onSelectDevice('mobile')"
                    ></dsn-button-rounded>
                </div>
            </div>
            <div fxLayout="row" class="gap-16" fxFlex style="height: 100%">
                <div
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    fxFlex
                    style="overflow-y: auto; overflow-x: hidden; height: 100%"
                >
                    @if (reportType) {
                        @if (reportType === "dashboard") {
                            <app-report-dashboard
                                fxLayout="column"
                                fxFlex
                                [previewMode]="true"
                                [style]="
                                    device === 'desktop'
                                        ? 'width: 100%'
                                        : 'width: 430px'
                                "
                                (handleReport)="onChangeReport($event)"
                            ></app-report-dashboard>
                        } @else if (
                            ["dre", "dreComparation"].includes(reportType) ||
                            report?.isDREWithBalance
                        ) {
                            <app-report-dre
                                fxLayout="column"
                                fxFlex
                                [previewMode]="true"
                                [style]="
                                    device === 'desktop'
                                        ? 'width: 100%'
                                        : 'width: 430px'
                                "
                                (handleReport)="onChangeReport($event)"
                            ></app-report-dre>
                        } @else if (
                            ["balance", "balanceComparation"].includes(
                                reportType
                            )
                        ) {
                            <app-report-balance
                                fxLayout="column"
                                fxFlex
                                [previewMode]="true"
                                [style]="
                                    device === 'desktop'
                                        ? 'width: 100%'
                                        : 'width: 430px'
                                "
                                (handleReport)="onChangeReport($event)"
                            ></app-report-balance>
                        } @else if (["budget"].includes(reportType)) {
                            <app-report-budget
                                [previewMode]="true"
                                [style]="
                                    device === 'desktop'
                                        ? 'width: 100%'
                                        : 'width: 430px'
                                "
                                (handleReport)="onChangeReport($event)"
                            ></app-report-budget>
                        } @else if (["projection"].includes(reportType)) {
                            <app-report-projection
                                [previewMode]="true"
                                [style]="
                                    device === 'desktop'
                                        ? 'width: 100%'
                                        : 'width: 430px'
                                "
                                (handleReport)="onChangeReport($event)"
                            ></app-report-projection>
                        }
                    }
                </div>
                @if (report && chatNandaService.isOpen) {
                    <div
                        fxLayout="column"
                        style="height: 100%"
                        [hidden]="!chatNandaService.isOpen"
                    >
                        <app-nanda-chat-accounting
                            fxLayout="column"
                            fxFlex
                            [report]="report"
                            (onClose)="onCloseChat()"
                        ></app-nanda-chat-accounting>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
